<template>
    <div class="vx-col w-full">
        <div class="vx-col w-full text-center mb-4" v-if="is_preview && img_src">
          <img :src="img_src" :title="title" style="display:initial; width:50%; height:auto" />
          <div class="mb-3"><small><i>Preview</i></small></div>
          <div class="text-center">
            <vs-button type="filled" color="danger" size="small" @click="onClickRemoveImage()">Remove</vs-button>
          </div>
        </div>
        <div class="vx-col w-full mb-4">
          <div class="image-upload-wrap">
            <input class="file-upload-input" type='file' @change ="onUploadImage" ref="imageUpload" accept="image/*" />
            <div class="drag-text">
              <p class="font-bold mb-2">{{title}}</p>
              <p>{{desc}}</p>
            </div>
          </div>
        </div>
    </div>
</template>

<script>

import Crypto           from '@/helper/crypto'
import ErrorHandler     from '@/helper/error_handler'
import Global           from '@/helper/global'

export default {
    name: 'input-image',
    props: ['title', 'desc'],
    props: {
        title: {
            type: String,
            default: ''
        },
        desc: {
            type: String,
            default: ''
        },
        is_preview: {
            type: Boolean,
            default: true
        }
    },
    data () {
        return {
          img_src: null
        }
    },
    methods: {
        onClickRemoveImage(){
          this.img_src = null
          this.$emit('onRemoveImage')
        },
        onUploadImage(e){
          let file = this.$refs.imageUpload.files[0];

          if(file){
            const isLt2M = file.size / 1024 / 1024 < 2;
            const isImage = file.type ==='image/jpeg' || file.type ==='image/png' || file.type ==='image/jpg'

            if (!isImage) {
              this.$vs.notify({
                color:'danger',
                title:'VIAMOVE SYSTEM',
                text: 'File type is not an image!'
              })

              return
            }

            if (!isLt2M) {
              this.$vs.notify({
                color:'danger',
                title:'VIAMOVE SYSTEM',
                text: 'Maximum file size 2MB!'
              })

              return
            }

            this.img_src = URL.createObjectURL(file)

            this.$emit('onUploadImage', file)

          } else {
            this.$vs.notify({
              color:'danger',
              title:'VIAMOVE SYSTEM',
              text: 'No file detected!'
            })
          }
        }
    }
}
</script>
